__webpack_public_path__ = App.publicPath; // eslint-disable-line camelcase
